// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".color-picker[data-v-482e23ad]{cursor:pointer}.color-picker[data-v-482e23ad]::-webkit-color-swatch-wrapper{border:none}.color-picker[data-v-482e23ad]::-webkit-color-swatch{border:none}", ""]);
// Exports
module.exports = exports;
